import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redir',
  templateUrl: './redir.component.html',
  styleUrls: ['./redir.component.scss']
})
export class RedirComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
